import React from 'react';

import { makeStyles } from "@material-ui/core/styles";

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CardHeader from '@material-ui/core/CardHeader';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Divider from '@material-ui/core/Divider';

import Editor from '../QuillEditor/Editor';

import SuggestionsDialog from './SuggestionsDialog';


const useStyles = makeStyles(theme => ({
    card: {
        margin: theme.spacing(2),
    },
    cardWrapper: {
        maxWidth: '920px',
        margin: 'auto',
    },
    cardHeader: {
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        textAlign: 'center',
        padding: theme.spacing(1),
    },
    cardContent: {
        '& p': {
            marginBottom: 0,
            minHeight: '1rem'
        }
    },
    cardContentPreview: {
        border: '1px solid #ffff',
        padding: 2,
        minHeight: 40,
        '&:hover' : {
            cursor: 'text',
            borderColor: theme.palette.grey[100],
        },
    },
}));


const CeremonyCard = (props) => {
    const classes = useStyles();

    const [editing, setEditing] = React.useState(false);

    const {
        section_name,
        section_id,
        section_instruction,
        section_default,
        text
    } = props.section;

    const {
        setOuterEditing
    } = props;

    const {
        id,
        bride_first_name,
        groom_first_name,
        officiant_first_name,
        officiant_last_name,
        officiant_email,
        wedding_date_formatted,
        location,
    } = props.couple;

    const newlines = (text) => (
        text.replace(/\n/g, '<br/>')
    );

    const piping = text => (
        text
        ? text.replace(/\{couple_bride_firstname\}/g, bride_first_name)
            .replace(/\{couple_groom_firstname\}/g, groom_first_name)
            .replace(/\{user_firstname\}/g, officiant_first_name)
            .replace(/\{user_lastname\}/g, officiant_last_name)
            .replace(/\{user_email\}/g, officiant_email)
            .replace(/\{couple_wedding_location\}/g, location ? location : '')
            .replace(/\{couple_date_wedding\}/g, wedding_date_formatted)
        : ''
    );

    const [html, setHtml] = React.useState(text ? text : newlines(piping(section_default)));

    const toggleEditing = () => {
        setEditing(!editing);
        setOuterEditing(!editing);
    }

    const handleSaveClick = () => {
        toggleEditing(!editing);
        let html = editorRef.current.value;

        if (html == '<p></p>' || html == '<p><strong></strong></p>') {
            html = '';
        }
        setHtml(html);

        const data = {
            _token: window._token,
            text: html
        };
        /* TODO: handle fails */
        new Promise((resolve, reject) => {
            let url = `/api/ceremony/${id}/${section_id}`
            fetch(url, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    const allOpenEditors = Array.from(document.getElementsByClassName('cardSaveButton'));
                    allOpenEditors.map((element) => {
                        element.click();
                    });
                })
        });
    }

    const editorRef = React.createRef();

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
        setEditing(false);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const showSuggestionsButton = window.canViewSuggestions && section_name !== 'Your Wedding Team';

    return (
        <div className={classes.cardWrapper} id={`ceremony-card--${section_id}`}>
            <Card className={classes.card}>
                <CardHeader
                    title={section_name}
                    className={classes.cardHeader}
                    titleTypographyProps={{
                        variant: "h6"
                    }}
                />
                <CardContent className={classes.cardContent}>
                    {!editing &&
                        <div className={classes.cardContentPreview} onClick={toggleEditing} dangerouslySetInnerHTML={{__html: newlines(html)}} />
                    }
                    {editing && 
                        <Editor
                            initialValue={html}
                            ref={editorRef}
                        />
                    }
                </CardContent>
                <Box my={1}>
                    <Divider />
                </Box>
                <CardActions>
                    {editing &&
                        <div>
                            <Button size="small" color="primary" onClick={handleSaveClick} className="cardSaveButton">
                                Save
                            </Button>
                            <Button size="small" onClick={toggleEditing}>
                                Cancel
                            </Button>
                        </div>
                    }
                    {showSuggestionsButton && (
                        <Button size="small" color="primary" variant="outlined" onClick={handleClickOpen}>
                            View Suggestions
                        </Button>
                    )}
                </CardActions>
            </Card>
            <SuggestionsDialog
                open={open}
                scroll='paper'
                handleClose={handleClose}
                title={section_name}
                weddingId={id}
                sectionId={section_id}
                sectionInstruction={section_instruction}
                sectionText={html}
                brideFirstName={bride_first_name}
                groomFirstName={groom_first_name}
                officiantFirstName={officiant_first_name}
                setHtml={setHtml}
            />
        </div>
    );
}

export default CeremonyCard;
